import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sortArray } from '@nu-art/ts-common';
import { Button, ComponentSync, LL_H_C, LL_V_L, ThunderDispatcher, TS_Checkbox, TS_CheckboxGroup } from '@nu-art/thunderstorm-frontend';
import { EM_RefSystems, UnresolvedCodeStatuses } from '@app/runtime-tools-shared';
import { ModuleFE_FHIRQuery } from '@app/fhir-frontend';
import { RefSystemLabels, StatusLabels } from './status-labels.js';
export const dispatcher_onUnresolvedCodeFiltersChange = new ThunderDispatcher('__onUnresolvedCodeFiltersChange');
export class Dialog_UnresolvedCodeFilters extends ComponentSync {
    //######################### Life Cycle #########################
    __onUnresolvedCodeFiltersChange = (data) => {
        this.setState({
            selectedStatuses: data.selectedStatuses,
            selectedRefSystems: data.selectedRefSystems,
            selectedFhirQueryIds: data.selectedFhirQueryIds ?? [],
            filterByHasSuggestedHv: data.filterByHasSuggestedHv ?? false,
        });
    };
    deriveStateFromProps(nextProps, state) {
        state.selectedStatuses ??= nextProps.selectedStatuses;
        state.selectedRefSystems ??= nextProps.selectedRefSystems;
        state.selectedFhirQueryIds ??= nextProps.selectedFhirQueryIds ?? [];
        state.filterByHasSuggestedHv ??= nextProps.filterByHasSuggestedHv ?? false;
        return state;
    }
    //######################### Logic #########################
    handleStatusSelectionChange = (selectedIds) => {
        this.dispatchFilters({
            selectedStatuses: selectedIds,
            selectedRefSystems: this.state.selectedRefSystems,
            selectedFhirQueryIds: this.state.selectedFhirQueryIds,
            filterByHasSuggestedHv: this.state.filterByHasSuggestedHv,
        });
    };
    handleRefSystemSelectionChange = (selectedIds) => {
        this.dispatchFilters({
            selectedStatuses: this.state.selectedStatuses,
            selectedRefSystems: selectedIds,
            selectedFhirQueryIds: this.state.selectedFhirQueryIds,
            filterByHasSuggestedHv: this.state.filterByHasSuggestedHv,
        });
    };
    handleFhirQuerySelectionChange = (selectedIds) => {
        this.dispatchFilters({
            selectedStatuses: this.state.selectedStatuses,
            selectedRefSystems: this.state.selectedRefSystems,
            selectedFhirQueryIds: selectedIds,
            filterByHasSuggestedHv: this.state.filterByHasSuggestedHv,
        });
    };
    dispatchFilters = (data) => {
        dispatcher_onUnresolvedCodeFiltersChange.dispatchUI(data);
        this.props.onFiltersChange?.(data);
    };
    handleHasSuggestedHvChange = (checked) => {
        this.dispatchFilters({
            selectedStatuses: this.state.selectedStatuses,
            selectedRefSystems: this.state.selectedRefSystems,
            selectedFhirQueryIds: this.state.selectedFhirQueryIds,
            filterByHasSuggestedHv: checked,
        });
    };
    onResetFilters = () => {
        this.dispatchFilters({
            selectedStatuses: [],
            selectedRefSystems: [],
            selectedFhirQueryIds: [],
            filterByHasSuggestedHv: false,
        });
    };
    //######################### Render #########################
    render() {
        return (_jsxs(LL_V_L, { className: 'unresolved-code__filters-dialog', children: [_jsxs(LL_H_C, { className: 'unresolved-code__filters__header', children: [_jsx("div", { className: 'unresolved-code__filters__title', children: "Filters" }), _jsx(Button, { onClick: () => this.onResetFilters(), children: "Reset" })] }), this.renderStatusFilters(), _jsx("div", { className: 'unresolved-code__filters__separator' }), this.renderRefSystemFilters(), _jsx("div", { className: 'unresolved-code__filters__separator' }), this.renderHasSuggestedHvFilter(), _jsx("div", { className: 'unresolved-code__filters__separator' }), this.renderFhirQueryFilters()] }));
    }
    renderStatusFilters = () => {
        const statusOptions = UnresolvedCodeStatuses.map((status) => ({
            id: status,
            label: StatusLabels[status]
        }));
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'unresolved-code__filters__title', children: "Status" }), _jsx(TS_CheckboxGroup, { parent: { id: 'statuses', label: 'All Statuses' }, options: statusOptions, selectedIds: this.state.selectedStatuses, onChange: this.handleStatusSelectionChange })] }));
    };
    renderFhirQueryFilters = () => {
        const fhirQueries = sortArray(ModuleFE_FHIRQuery.cache.allMutable(), query => query.label) ?? [];
        const fhirQueryOptions = fhirQueries.map(query => ({
            id: query._id,
            label: query.label
        }));
        if (!fhirQueryOptions.length)
            return;
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'unresolved-code__filters__title', children: "FHIR Query" }), _jsx(TS_CheckboxGroup, { parent: { id: 'fhirQueries', label: 'All FHIR Queries' }, options: fhirQueryOptions, selectedIds: this.state.selectedFhirQueryIds, onChange: this.handleFhirQuerySelectionChange })] }));
    };
    renderHasSuggestedHvFilter = () => {
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'unresolved-code__filters__title', children: "Suggested HCS Variable" }), _jsx("div", { className: 'ts-checkbox-group', children: _jsx("div", { className: 'ts-checkbox-group__children', children: _jsx(TS_Checkbox, { checked: this.state.filterByHasSuggestedHv, onCheck: this.handleHasSuggestedHvChange, children: "Has suggested HCS variable" }) }) })] }));
    };
    renderRefSystemFilters = () => {
        const refSystemOptions = EM_RefSystems.map((refSystem) => ({
            id: refSystem,
            label: RefSystemLabels[refSystem]
        }));
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'unresolved-code__filters__title', children: "Reference System" }), _jsx(TS_CheckboxGroup, { parent: { id: 'refSystems', label: 'All Systems' }, options: refSystemOptions, selectedIds: this.state.selectedRefSystems, onChange: this.handleRefSystemSelectionChange })] }));
    };
}
//# sourceMappingURL=Dialog_UnresolvedCodeFilters.js.map